import React from "react";
import ReactDOM from "react-dom";
import { createHTMLwrapperElement } from '../Utils.js';

class GetHTMLWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.wrapperId = props.id;
  }

  componentDidMount() {
    this.wrapper = createHTMLwrapperElement(this.wrapperId);
    this.forceUpdate(); // allow render() to run once wrapper exists
    // this.setState({}); // optional
  }

  render() {
    let wrapper = null;

    if (this.wrapper)  {
      wrapper = ReactDOM.createPortal(this.props.children, this.wrapper);
    }
    return wrapper;
  }
}

export default GetHTMLWrapper;
